import React, { memo } from 'react'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'

enum WORKSPACE_STATUSES {
  underReview = 'under_review',
  storingAward = 'storing_award',
  closed = 'closed',
  awarded = 'awarded',
  open = 'open',
}

interface IWorkspaceStatusTagProps {
  status?: string | null
  pricingRound: number
}

export const WorkspaceStatusTag = memo<IWorkspaceStatusTagProps>(({ pricingRound, status }) => {
  switch (status) {
    case WORKSPACE_STATUSES.underReview:
      return <Tag label='Awarding' size={TAG_SIZE.small} tagStyle={TAG_STYLE.success} />
    case WORKSPACE_STATUSES.awarded:
    case WORKSPACE_STATUSES.storingAward:
      return <Tag label='Awarded' size={TAG_SIZE.small} tagStyle={TAG_STYLE.dark} />
    case WORKSPACE_STATUSES.closed:
      return <Tag label='Closed' size={TAG_SIZE.small} tagStyle={TAG_STYLE.dark} />
    default:
      return (
        <Tag label={`Pricing R${pricingRound}`} size={TAG_SIZE.small} tagStyle={TAG_STYLE.info} />
      )
  }
})
